import Typography from "@mui/material/Typography";

import Divider from "components/Divider";
import Layout from "components/Layout";
import CustomLink from "components/CustomLink";

import { CONTACT_UNIQLY_EMAIL } from "utils/consts";

const TermsPage = () => {
  return (
    <Layout>
      {/* SERVICE TERMS */}
      <Typography variant="h2" paragraph mb={4}>
        Terms & Conditions
      </Typography>

      <Typography variant="h3" paragraph color="secondary">
        Uniqly Terms & Conditions
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        I. FOREWORD AND PREAMBLE
      </Typography>
      <Typography paragraph>
        This document named as Terms And Conditions of the services providing by
        UNIQLY includes provisions governing the services and establishes legal
        frames for the services providing by the UNIQLY named as the “Provider”
        or “Company” at the further part of this terms and conditions. The
        general rules introduced by the power of this document establishes the
        rights and obligations of the Provider, Partners and the Users and
        governs the relationship between the Provider and the User. The terms
        and conditions applied to all services, worldwide until the Provider
        decided, at his own discretion, to change, amend or modify any of the
        provisions of this document.
      </Typography>
      <Typography paragraph>
        UNIQLY deeply believes that the User(s) acts in the best faith, and any
        activity of the User involved with usage of the services provided by
        UNIQLY will not violate any rights of any person or company. As a
        professional and innovative Company, UNIQLY do everything to ensure that
        products and services provided by UNIQLY are not used to violate or
        disturb any rights of any business entity or a person. UNIQLY believes,
        that you act fair and your main goal is to freely create and express
        yourself through your creations and protect your intellectual property
        rights with the possibilities provided by NFT and blockchain technology.
        Hereinafter we grant you license for usage of our software and
        technology but we expect, that your activities involved with our
        technology will follow our rules.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        II. DEFINITIONS
      </Typography>
      <Typography paragraph>
        <b>PROVIDER</b> – UNIQLY INC. 1033 NE 95TH ST 33138-2547 MIAMI SHORES,
        EIN NUMBER: 92-2123574
      </Typography>
      <Typography paragraph>
        <b>USER</b> – a person (physical or legal) using the services provided
        by Provider according to the provisions terms and conditions.
      </Typography>
      <Typography paragraph>
        <b>PARTNER</b> – natural or legal person (legal entity) possessing the
        digital store on the website powered by UNIQLY. UNIQLY enables its
        partners to establish dedicated digital store on the internet platform
        powered by UNIQLY. Partners may sell digital products (NFT) by the store
        and Users may purchase such digital products. Please note, that UNIQLY
        as well as any of its subsidiaries.
      </Typography>
      <Typography paragraph>
        <b>PHYSICAL (NATURAL) PERSON</b> – a person who is legally permitted to
        enter into contractual relationships and, typically the age of 18 years.
      </Typography>
      <Typography paragraph>
        <b>LEGAL PERSON</b> – a legal entity established under the provisions of
        the law, legally permitted to act on his behalf on the market,
        especially to enter into contractual relations and the liabilities.
      </Typography>
      <Typography paragraph>
        <b>SERVICES</b> – all services provided by the Provider to the Users
        under the provisions of this terms of service. The scope of services
        covers the website as well as all functionalities involved with the
        website.
      </Typography>
      <Typography paragraph>
        <b>WEBSITE</b> – the internet domain, design and the source code of the
        website www.uniqly.io the unique internet address of the Provider, used
        by Provider to offer services to the Users.
      </Typography>
      <Typography paragraph>
        <b>APPLICABLE LAW</b> – the law of the state (jurisdiction) which
        applies to the legal relationships between Provider and User.
      </Typography>
      <Typography paragraph>
        <b>NFT</b> – Non Fungible Token. The technology based on blockchain,
        which allows the User to confirm your unique right to the physical thing
        the User may order.
      </Typography>
      <Typography paragraph>
        <b>ITEM</b> – the physical thing like a t-shirt or a a hoodie, designed
        by the Partner and produced and transported to the User by the Provider
        or a Partner.
      </Typography>
      <Typography paragraph>
        <b>PAYMENTS</b> – all transfers of assets, made with the fiat (fiduciary
        currencies) or with the cryptocurrencies, under the provisions of this
        terms of service. According to the provisions of these Terms and
        Conditions, all payments for the services offered by Provider can be
        made with cryptocurrencies and, If the provider add such feature, with
        fiduciary currencies.
      </Typography>
      <Typography paragraph>
        <b>THIRD PARTY RIGHTS</b> – the rights belonging to the third party,
        like copyrights, trademarks, industrial design rights, trade dresses or
        any other intellectual property rights, protected by the law.
      </Typography>
      <Typography paragraph>
        <b>LIMITATIONS OF LIABILITY</b> – the provisions that limits the
        liability of the Provider, especially applied to the situations of the
        violation of third party rights made by the User. Thus Provider does not
        accept any legal liability for the activities undertaken by the Users.
      </Typography>
      <Typography paragraph>
        <b>MINT</b> – shall mean publishing an NFT as an unrepeated digital
        asset on blockchain on which it can be traded, bought and sold and its
        digital data is converted into a crypto collection. Minting an NFT by a
        specific User is a representative of buying an NFT by the user by
        assigning the User as the owner of the NFT.
      </Typography>
      <Typography paragraph>
        <b>PHYSICAL REDEEM</b> – shall mean ordering the physical representative
        of an NFT. Only minted NFTs can be redeemed.
      </Typography>
      <Typography paragraph>
        <b>METAVERSE REDEEM</b> – shall mean enabling the NFT to be accessible
        by a specific wallet in the chosen metaverse.
      </Typography>
      <Typography paragraph>
        <b>STORE</b> – the digital store created by UNIQLY for the Partner
        enabling Users to purchase digital NFT token representing the specific
        design of t-shirt or hoodie.
      </Typography>
      <Typography component="div">
        <Typography paragraph>
          <b>Tier</b> - mean kinds of stores offered by UNIQLY.IO:
        </Typography>
        <ul>
          <li>
            <b>Tier 1 (called Production by Seller)</b> allows selling any kind
            of products. It is designated for the Partners that already have the
            physical items that they would like to sell as NFTs or would like to
            manufacture them themselves. Partner is fully responsible for the
            production and shipping of the redeemed physical items to the
            clients. Provider does not take any responsibility or store owner’s
            failure in manufacturing or delivery.
          </li>
          <li>
            <b>Tier 2 (called Production by Uniqly)</b> allows selling
            customizable T-shirts and hoodies. Provider takes full
            responsibility for the production and shipping of the redeemed
            physical items to the clients.
          </li>
          <li>
            <b>Tier 3 (called Premium Store)</b> includes all the configurations
            available in Tier1 and Tier2 stores, as well as designing 3D mockups
            of the products, adding scannable NFC tags to the physical products,
            option to redeem items to Decentraland and creating promotional
            materials. It is a service available on demand and is not possible
            to create via the Store Generator. Application for the Premium Store
            is available via e-mail (
            <CustomLink href={`mailto:${CONTACT_UNIQLY_EMAIL}`}>
              contact@uniqly.io
            </CustomLink>
            ).
          </li>
        </ul>
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        III. SERVICES
      </Typography>
      <Typography paragraph>
        1. User, according to the provisions of these terms of service is
        entitled to use and enjoy the services provided by the Provider through
        the Website.
      </Typography>
      <Typography paragraph>
        2. User will accept all provisions of this terms and conditions and
        other regulations which applies to the User (e. g. Privacy Policy and
        other documents governing the terms of services provided by the
        Provider.
      </Typography>
      <Typography paragraph>
        3. The Provider is an owner of all intellectual property and other
        rights, title and interest in and to its site and service (except for
        user-provided content). The usage of the site and service does not grant
        any express or implied right, title or interest to these properties,
        except as follows. .User is eligible to use the website and service in
        accordance with terms, rules, and guidelines found on its site and
        established by the Provider.
      </Typography>
      <Typography paragraph>
        4. The Provider may revoke this license and limit the access to the site
        or particular services in accordance with the provisions of this terms
        of service.
      </Typography>
      <Typography paragraph>
        5. The website as well as any services are provided “us such” and the
        User is not eligible to modify, change or amend any elements of the
        website or the source code displayed by the internet browser installed
        on the device belonging to the User.
      </Typography>
      <Typography paragraph>
        6. The service provided by UNIQLY is powering and providing the internet
        digital platform enabling Partners of UNIQLY to sell their digital and
        physical product. UNIQLY is not, and shall not be, under any
        circumstances, the seller of digital NFT tokens representing physical
        items or physical items redeemed by the User. Please note, that UNIQLY
        provides the technology and its support, but the contractual
        relationship between the Seller and the Purchaser concluded by
        purchasing the digital NFT item on the platform shall not engage the
        Provider and Provider shall not be deemed as a party to the transaction
        made through the platform.
      </Typography>
      <Typography paragraph>
        7. The Provider may extend the scope of the business activity of the
        Provider by adding the own store possessed by the Provider to the
        website and selling digital NFTs as well as physical goods through the
        digital store. If the Provider decides to introduce new products
        involved with launching the digital store on the internet platform
        powered by the Provider, all provisions of this terms of services
        applicable to the Partners possessing the store and contractual
        relationship between the User (Purchaser) and the Partner (Seller) shal
        apply respectively to the Provider.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        IV. CHANGES OF THE TERMS AND CONDITIONS
      </Typography>
      <Typography paragraph>
        1. These terms and conditions may be changed, amended or modified by the
        decision of the Provider at his own discretion. The Provider is
        constantly improving the service and extending the scope of services to
        meet the highest standards and provide the best services to the Users.
      </Typography>
      <Typography paragraph>
        2. If the Provider decides to change these terms and conditions, the
        User will be informed via e-mail of the changes and asked to accept
        amendments introduced by new terms and conditions to continue using
        services provided by our Company.
      </Typography>
      <Typography paragraph>
        3. If the User disagrees with amendments introduced to the terms and
        conditions the User is strictly obliged to immediately finish the using
        of our services (website, other services).
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        V. LIMITATION OF LIABILITY & INDEMNIFICATION
      </Typography>
      <Typography paragraph>
        1. The User certifies and confirms that the User uses the website and
        services provided by the Provider at the own risk of the User.
      </Typography>
      <Typography paragraph>
        2. The Provider provides its site and service without any express or
        implied warranties. Uniqly is not responsible for the actions, content,
        information, or data of third parties.
      </Typography>
      <Typography paragraph>
        3. The User release the Provider as well as the directors, officers,
        employees, and agents of the Provider from any express or implied
        liability for any loss or and damages, known and unknown, arising out of
        or in any way connected with any loss or damage you may suffer in
        connection with any usage of the services provided by UNIQLY or any
        third party.
      </Typography>
      <Typography paragraph>
        4. Thus the User fully confirms that the limitation of liability and
        indemnification granted above in points 1- 3 is irrevocable and the User
        cannot revoke the indemnification stated above.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        VI. FORBIDDEN USE OF THE SERVICE
      </Typography>
      <Typography paragraph>
        1. By accepting these terms and conditions, User accepts and
        acknowledges that some activities, especially activities listed below,
        will be considered illegal and prohibited according to the law, the
        terms and conditions and the policy of the Provider.
      </Typography>
      <Typography paragraph>2. Forbidden use are as follows:</Typography>
      <Typography paragraph>
        a&#41; any interference with the website or services in general using
        the viruses, malware, or any other computer programs or technologies,
        designed to disrupt or damage any software or hardware, including any
        form of injection of source code through the website,
      </Typography>
      <Typography paragraph>
        b&#41; any use of a robots or any other software designed to
        automatically monitor activity on or copy information from the site or
        the service, except search engines, traffic counters or similar basic
        performance monitoring technology,
      </Typography>
      <Typography paragraph>
        c&#41; any impersonation for another person or entity,
      </Typography>
      <Typography paragraph>
        d&#41; any act of copying, modifying, creating derivative work from,
        reverse engineering, decompiling or disassembling any technology used to
        provide the site and service,
      </Typography>
      <Typography paragraph>
        e&#41; use any graphics, photos, meta tags, terms, keywords, or similar
        tags that contain the name of Provider or trademarks or third party
        trademarks nor third party copyrights,
      </Typography>
      <Typography paragraph>
        f&#41; engage in any activity that interferes with another user's
        ability to use or enjoy the site and service, including activity that
        places a disproportionate burden on the site and service compared to
        ordinary use from a single, ordinary user,
      </Typography>
      <Typography paragraph>
        g&#41; assist or encourage any third party in engaging in any activity
        prohibited by this terms of service,
      </Typography>
      <Typography paragraph>
        h&#41; use the site and service to promote hate speech, obscenity, or
        any content that violates customary standards{" "}
        <b>or rights of any person (physical or legal) or group of people.</b>
      </Typography>
      <Typography paragraph>
        <b>
          {" "}
          3. All listed above in points a&#41; to g&#41; forms of forbidden
          usage of the token and the services provided by Uniqly are strictly
          forbidden under the provisions of this terms {"&"} conditions.If
          Uniqly find the activity of the User as a forbidden practice listed in
          points a&#41; – g&#41;, Uniqly will, at his own discretion,
          immediately ban (block) the User from the access of all services
          provided by Uniqly. Uniqly reserves the right to disallow user from
          access to services provided by Uniqly and perpetually deny the User
          account.
        </b>
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        VII. VIRTUAL ITEMS, NFT TOKENS AND REDEEM PROCESS
      </Typography>
      <Typography paragraph>
        1. Users are allowed to purchase virtual items (projects t-shirts,
        hoodies, etc.) in the stores belonging to the Partners of the Provider.
      </Typography>
      <Typography paragraph>
        2. If you purchase the digital product, the product is available as an
        NFT token.
      </Typography>
      <Typography paragraph>
        3. Please note, that The Provider is responsible only for providing
        appropriate technology enabling Partners to offer the NFTs via a
        dedicated store created on the UNIQLY website. The User purchases the
        NFT directly from the Partner possessing the Store, The NFTs available
        to purchase in digital stores ares designed and created by the Partners
        possessing the stores.
      </Typography>
      <Typography paragraph>
        4. If You want to transfer your NFT into real life, You can order a
        physical thing (hoodie, t-shirt) prepared for you on the basis of your
        digital NFT purchased in store.
      </Typography>
      <Typography paragraph>
        5. Please note that there are two categories of stores on our platform.
        The category of store (TIER 1 or TIER 2) determines the scope of
        cooperation between the possessor of the store and the Provider.
      </Typography>
      <Typography paragraph>
        6. If you purchase products from the store categorized as TIER 1 store,
        the Provider shall not be, under any circumstances, liable for the
        quality of the products provided by the Partner possessing the store.
      </Typography>
      <Typography paragraph>
        7. If you purchase products from the store categorized as TIER 1 store,
        the Partner possessing the store is fully liable for the quality of
        providing physical products.The products are manufactured by the TIER 1
        store possessor or its subsidiaries and the Provider does not control
        the production process and cannot be responsible for the effects of the
        production process.
      </Typography>
      <Typography paragraph>
        8. If you purchase products from the store categorized as TIER 2 store,
        the process of manufacturing of the physical products is managed by the
        Provider but the Provider shall be free from any express or implied
        liability for the effects of the manufacturing process due to the
        limitations involved with producing the customized goods on personalized
        demand of the customer purchasing the product. Please note, that the
        Provider is not, and shall not be deemed, as a Seller of any digital
        NFTs as well as any redeemed physical products. The products ordered by
        the User are sold by the Partner operating the digital store.
      </Typography>
      <Typography paragraph>
        9. Please note that the Provider shall not be, under any circumstances,
        liable for any statements, declarations or representations as well as
        for the quality of physical products and the design of NFTs provided by
        the TIER 1 store or the person(s) acting on behalf of the store or for
        the benefit of the store.
      </Typography>
      <Typography paragraph>
        10. User fully accepts, understands and acknowledges that the Provider
        provides only technology enabling the Partner to create and manage the
        digital store and the Provider is free from any possible liability for
        any loss or damage eventually made by the Partner to the User.
      </Typography>
      <Typography paragraph>
        11. If you order a physical product, we provide you an NFC pin which
        joins the product with our database. The link included into the NFC pin
        allows you to check the history of your item.NFC code records all
        changes involved with your item from the creation of the item for all
        time.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        VIII. PRICES & PAYMENTS
      </Typography>
      <Typography paragraph>
        1. The services provided by UNIQLY are paid.
      </Typography>
      <Typography paragraph>
        2. All prices displayed on the website are final prices and the prices
        can change from time to time.
      </Typography>
      <Typography paragraph>
        3. Prices presented on the website does not include additional costs
        involved with handling the transaction by the external payment
        intermediary provider (in case of payment via payment gateway with the
        usage of fiduciary currency, credit card or bank transfer) the commision
        of the provider will be added to the price, standard level of commision
        is 5%. The price shall be rounded up to the closest 10.
      </Typography>
      <Typography paragraph>
        4. Payments for the products offered through the website by Partners
        shall be made in cryptocurrencies displayed on the website or via
        cryptocurrency payment gateway with fiduciary money if the Provider
        introduces the payments in fiduciary currencies, with fiduciary
        currencies.
      </Typography>
      <Typography paragraph>
        5. The products offered by the Partners are paid in accordance with the
        prices set out by the Partners on the stores.
      </Typography>
      <Typography paragraph>
        6. The prices of physical products may not contain the cost of shipping
        and redeem of the NFT to the physical product.
      </Typography>
      <Typography paragraph>
        7. The payments in cryptocurrencies can be made with the usage of
        following blockchains: ETH (ethereum), POLYGON and BINANCE (BNB). The
        Partner possessing the store may add their own native utility payment
        token and accept the payments made with the token.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        IX. DISCLAIMERS
      </Typography>

      <Typography paragraph>
        1. The Provider provides the site and service on an "as is" and "as
        available" basis. The Provider does not represent or warrant that the
        site and service or its use:
      </Typography>
      <Typography paragraph>
        a) will be uninterrupted, timely, safe, or secure,
      </Typography>
      <Typography paragraph>
        b) will be free of inaccuracies, errors, or vulnerabilities,
      </Typography>
      <Typography paragraph>
        c) will meet your expectations or requirements, or
      </Typography>
      <Typography paragraph>
        d) will operate in the configuration or with the hardware or software
        you use. The Provider hereby disclaims any and all express or implied
        warranties, including without limitation, warranties of fitness for a
        particular purpose, merchantability, and non-infringement to the fullest
        extent of the law, except to the extent that this agreement provides
        otherwise.
      </Typography>
      <Typography paragraph>
        2. The User agrees that the Provider has limited and excluded the
        responsibility of the Provider for any damages suffered by the User in
        connection with the site and service, and that use of the site and
        service, including all content, data or software distributed by,
        downloaded, or accessed from or through the site and service, is at your
        sole risk. You understand and agree that the User will be solely
        responsible for any damage to the User, business belonging to the User
        or the computer system belonging to the User or any loss of data that
        results from the User actions and usage of the site and service.
      </Typography>
      <Typography paragraph>
        3. The Provider does not control or endorse in any respect any
        information, products, or services offered by third parties through the
        site and service and shall not be, under any circumstances responsible
        or liable for any possible representations and warranties these third
        parties may make.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        X. DATA PROTECTION
      </Typography>
      <Typography paragraph>
        1. Provider may collect and use information and data provided by the
        User in accordance with its privacy policy.
      </Typography>
      <Typography paragraph>
        2. The general and basic purpose of collecting and processing digital
        data and information.
      </Typography>
      <Typography paragraph>
        3. Provider introduces appropriate procedures, methods and techniques
        designed to protect the digital data and information provided by the
        User.
      </Typography>
      <Typography paragraph>
        4. Although the Provider acts with proper care and due diligence
        required by law, the Provider cannot be liable for any technical issues
        or any other consequences of any possible digital hacking attacks
        targeted against the website as well as the Users of the website.
      </Typography>
      <Typography paragraph>
        5. The User fully accepts and acknowledges that the User is solely
        responsible for the proper securing of the information and data
        belonging to the User, keeping the sensitive information belonging to
        the User confidential.
      </Typography>
      <Typography paragraph>
        6. The User fully accepts and acknowledges that the User is solely
        responsible for introducing proper rules of protection of the device
        belonging to the User as well as any data stored on the device.
      </Typography>
      <Typography paragraph>
        7. The User fully accepts and acknowledges that the User is fully liable
        for all consequences of the password disclosure made by the User to any
        third party.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        XI. TERMINATION OF ACCESS
      </Typography>
      <Typography paragraph>
        The Provider may refuse to provide its site and service to the User
        (terminate the access to the services), in full or in part, effective
        immediately and without notice, for any reason or no reason, but
        especially if the Provider believes that the User (or any other natural
        or legal person whom the Provider believes that the User act in concert
        with) have violated or will violate any laws, rights, or term (or the
        spirit of any term) of thus document or if the Provider believes in its
        sole discretion that the usage of the site and service by the User may
        create any risk (including any legal risk) for the Provider or another
        Users. Limitation of access may include removal or modification of
        content that the User have uploaded or otherwise sent to or through the
        site and service.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        XII. FORCE MAJEURE
      </Typography>
      <Typography paragraph>
        In case of any cause outside reasonable control of any of the parties,
        including acts of god, riot, war, malicious acts of damage, fires,
        electricity supply failure and Government authority, neither party is
        liable for delay in meeting its obligations arising out of these terms
        of service.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        XIII. SEVERABILITY
      </Typography>
      <Typography paragraph>
        If any of the provisions aforementioned in these Terms of Service is
        found to be invalid and/or unenforceable under any applicable law, it
        shall not render these Terms unenforceable and/or invalid as a whole,
        and such provisions shall be deleted without any effect on remaining
        provisions whatsoever.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        XIV. SURVIVAL
      </Typography>
      <Typography paragraph>
        If any of the provisions aforementioned in these Terms of Service are to
        be found void, invalid, unenforceable or illegal by a court of law,
        validity and enforceability of other provisions shall not be affected in
        any way. If any provisions are to be declared unenforceable, you agree
        to an amendment made by the Provider to provide for the enforcement of
        those provisions to the fullest extent permitted by applicable law.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        XV. ENTIRE AGREEMENT
      </Typography>
      <Typography paragraph>
        These Terms of Service together with the other legal documents published
        on the website such as policies or any notices and disclaimers issued on
        this Website, constitute an entire agreement between the User and the
        Provider governing all relations involved with usage of the website and
        the services provided by the website.
      </Typography>

      <Divider my={5} />

      {/* GENERATOR TERMS */}
      <Typography variant="h3" paragraph color="secondary">
        Store Generator Terms of Service
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        PREAMBLE & FOREWORD
      </Typography>

      <Typography paragraph>
        By the power of this Terms and Conditions of Service, Provider defines
        the rules of cooperation between Partner and Provider, essential terms
        and conditions of the cooperation, scope of services of Provider,
        methods of payments, duration of cooperation and any and all matters
        essential for the Parties involved with cooperation of Parties under the
        power of this Terms of Service hereby.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        I. DEFINITIONS
      </Typography>
      <Typography paragraph>
        In this TERMS AND CONDITIONS OF SERVICE the following definitions apply:
      </Typography>
      <Typography paragraph>
        <b>Assets</b> - all graphics provided by Partner in the Store Generator,
        being graphic elements of the store like avatar, banner or background.
      </Typography>
      <Typography paragraph>
        <b>NFT</b> - shall mean Non Fungible Token - digital token confirming
        uniqueness of the graphic or any other digital file attached and signed
        by the NFT token.
      </Typography>
      <Typography paragraph>
        <b>Smart contract</b> - program or protocol stored on blockchain that
        runs automatically when specific predetermined conditions are met.
      </Typography>
      <Typography paragraph>
        <b>Mint</b> - shall mean publishing an NFT as an unrepeated digital
        asset on blockchain on which it can be traded, bought and sold and its
        digital data is converted into a crypto collection. Minting an NFT by a
        specific User is a representative of buying an NFT by the user by
        assigning the User as the owner of the NFT.
      </Typography>
      <Typography paragraph>
        <b>Physical redeem (redeem)</b> - shall mean ordering the physical
        representative of an NFT. Only minted NFTs can be redeemed.
      </Typography>
      <Typography paragraph>
        <b>Metaverse redeem</b> - shall mean enabling the NFT to be accessible
        by a specific wallet in the chosen metaverse. This option is available
        for Tier3 Stores only.
      </Typography>
      <Typography paragraph>
        <b>Order form (Store Generator)</b> - the digital form the Partner may
        fill with details of the store the Partner is willing to create on
        UNIQLY.IO platform.
      </Typography>
      <Typography paragraph>
        <b>Partner</b> - partner of UNIQLY and eligible to create the digital
        store and purchase digital services provided by UNIQLY under the power
        of this Terms & Conditions of Services. Partner shall mean any legal
        entity e.g. companies, corporations, partnerships, foundations or any
        entity not meant above but created as business entity under any law of
        any jurisdiction or any natural person with the residence (domicile) in
        any jurisdiction purchasing UNIQLY.IO services and accepting this Terms
        & Conditions of Service.
      </Typography>
      <Typography paragraph>
        <b>Payment token</b> - digital payment token acceptable as a means of
        payment by Provider. Provider accepts digital payment tokens as a form
        of payment for services provided by Provider and for products offered by
        the Partner in a digital store powered by Provider.
      </Typography>
      <Typography paragraph>
        <b>Provider</b> - shall mean UNIQLY INC. (Incorporated) registered in
        Miami Shores under the EIN number 92-2123574 with the registered
        address: 1033 NE 95TH ST 33138-2547 MIAMI SHORES
      </Typography>
      <Typography paragraph>
        <b>User</b> - client eligible to mint and redeem the products available
        in the Stores.
      </Typography>
      <Typography paragraph>
        <b>Services</b> - shall mean any and all services involved with creation
        and maintenance of the store, digital graphics and models of items.
      </Typography>
      <Typography paragraph>
        <b>Store</b> - shall mean digital store provided by UNIQLY.IO in
        accordance with provisions of these Terms & Conditions, enabling the
        Partner to sell his collection of NFT. The digital store will be a
        separate site created on the uniqly.io domain.
      </Typography>
      <Typography component="div">
        <Typography paragraph>
          <b>Tier</b> - mean kinds of stores offered by Provider:
        </Typography>
        <ul>
          <li>
            <b>Tier 1 (called Production by Seller)</b> allows selling any kind
            of products. It is designated for the Partners that already have the
            physical items that they would like to sell as NFTs or would like to
            manufacture them themselves. Partner is fully responsible for the
            production and shipping of the redeemed physical items to the
            clients. Provider does not take any responsibility or store owner’s
            failure in manufacturing or delivery.
          </li>
          <li>
            <b>Tier 2 (called Production by Uniqly)</b> allows selling
            customizable T-shirts and hoodies. Provider takes full
            responsibility for the production and shipping of the redeemed
            physical items to the clients.
          </li>
          <li>
            <b>Tier 3 (called Premium Store)</b> includes all the configurations
            available in Tier1 and Tier2 stores, as well as designing 3D mockups
            of the products, adding scannable NFC tags to the physical products,
            option to redeem items to Decentraland and creating promotional
            materials. It is a service available on demand and is not possible
            to create via the Store Generator. Application for the Premium Store
            is available via e-mail (
            <CustomLink href={`mailto:${CONTACT_UNIQLY_EMAIL}`}>
              contact@uniqly.io
            </CustomLink>
            ).
          </li>
        </ul>
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        II. CONCLUSION OF THE AGREEMENT AND THE ENTIRE AGREEMENT
      </Typography>
      <Typography paragraph>
        1. The digital store on UNIQLY.IO platform may be created by Partners.
      </Typography>
      <Typography paragraph>
        2. By completing the Store via Store Generator Partner accepts this
        Terms and Conditions of Service and agrees to all provisions of this
        Terms and Conditions of Service.
      </Typography>
      <Typography paragraph>
        3. Terms and Conditions as well as any and all Terms & Conditions and
        Policies conclude the entire agreement between Partner and Provider
        regarding the Store Generator.
      </Typography>
      <Typography paragraph>
        4. In the Store Generator Partner will specify details of the order,
        including number of digital 3D visualisations (this option is available
        in TIER2 only), design and technological aspects of creating a store for
        the Partner.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        III. SUBJECT OF THE COOPERATION
      </Typography>
      <Typography paragraph>
        1. Provider obligates itself to provide and maintain a digital store for
        NFT collection designed by Partner on the basis of projects and
        materials prepared by Partner in exchange for payment of price for the
        services provided by Provider.
      </Typography>

      <Typography component="div">
        <Typography paragraph>
          2. The scope of services of Provider includes:
        </Typography>
        <ol type="a">
          <li>
            Creating digital store for NFT collection on the basis of the Store
            Generator submitted by the Partner.
          </li>
          <li>
            Preparing a defined number of different products of NFTs for the
            Partner - please note that this option is available in TIER2 store
            only, if the Partner chooses to launch the TIER1 store, the Partner
            is responsible for preparing the products.
          </li>
          <li>
            Preparing a defined number of digital 3d visualisations of NFT for
            the Partner (visual reference of NFTs) by allowing the Partner to
            use the digital visualisation generator created and designed by
            Provider - this option is available in TIER2 stores only.
          </li>
          <li>
            Shipping products is handled by the Provider, if the store is
            classified as a TIER2 store.
          </li>
          <li>
            Producing the physical products on the basis of graphics and designs
            provided by Partner is handled by Provider, if the store is
            classified as TIER2.
          </li>
          <li>
            Provider does not offer any form of financial intermediation,
            financial or asset management, cryptocurrency custodial wallet
            services or any other service involved with finance. Blockchain
            solutions adopted by Provider ensure the total technical separation
            between cryptocurrencies earned by Provider on the basis of
            commission fee and the money earned by the Partner.
          </li>
        </ol>
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        IV. PRICES, TERMS OF PAYMENTS AND INVOICES
      </Typography>
      <Typography paragraph>
        1. Partner is eligible to add up to 3 products to the store.
      </Typography>
      <Typography paragraph>
        2. Partner cryptocurrency wallet address for commission transfers will
        be specified in the Part “SMART CONTRACTS” of the Store Generator.
      </Typography>
      <Typography paragraph>
        3. Provider is entitled to receive a percentage fee, established between
        the parties, from all operations of minting and redeeming NFTs of each
        item accessible on the Partner store.
      </Typography>
      <Typography paragraph>
        4. Any possible revenues generated by the store will be divided between
        Provider and Partner on the basis of the technological solution based on
        blockchain technology. Smart contract powered by Provider will divide
        any payments between Provider and Partner.
      </Typography>
      <Typography paragraph>
        5. Provider confirms and certifies that the blockchain smart contract
        upon which the transfers are made, ensures that Provider does not
        control, collect, manage or transfer any funds expressed in the form of
        virtual currencies units belonging to the Partner or any other third
        party in TIER1 and TIER2 Stores.
      </Typography>
      <Typography paragraph>
        6. Price for the service of creation and maintenance of the store is
        one-time payment. After the store is published, it is possible to extend
        its duration with another one-time payment.
      </Typography>
      <Typography paragraph>
        7. Payment for the store shall be made from the Store Generator level,
        in the Payments tab after the Partner completes all information required
        by the Provider.
      </Typography>
      <Typography paragraph>
        8. Payment for the store shall be made with virtual currency units on
        the Ethereum, Polygon and BSC Blockchain networks with the following
        digital currencies: ETH, UNIQ, USDC for Ethereum blockchain, MATIC,
        UNIQ, WETH on Polygon blockchain and BNB on BSC blockchain or with FIAT
        through the cryptocurrency payment gateway provided by third party.
      </Typography>
      <Typography paragraph>
        9. If the Partner decides to pay for the store with FIAT currency, the
        costs of payment processing shall be added to the final price of the
        store as a transaction fee for the third party. The transaction fee for
        FIAT payments is 5% rounded up to the nearest dollar.
      </Typography>
      <Typography paragraph>
        10. If the Partner chooses to pay for the store with a digital utility
        token issued by the Provider (UNIQ token) the price shall be lowered by
        50%. The discount is granted to intend Partners to choose UNIQ token as
        means of payment in the transaction of purchasing the Store.
      </Typography>
      <Typography paragraph>
        11. Unless the price is unpaid, the Provider is not obliged to start any
        works including designing graphics, 3D visualisations or any programming
        works necessary to launch the store as well as delay the publication of
        the store until the all price will be transferred successfully to the
        Provider.
      </Typography>
      <Typography paragraph>
        12. The price specified above covers the cost of Provider services
        associated with the store creation and maintenance on the platform and
        does not include any further services involved with mint and redeem
        processes. The scope of services regarding TIER1 and TIER2 is specified
        in this document.
      </Typography>
      <Typography paragraph>
        13. Provider will prepare the store for the Partner where Users can buy
        NFTs. Price for buying (minting) one NFT shall be specified by the
        Partner in Store Generator in tab “Products”. The Partner is eligible to
        define and establish the price for each product, but the price proposed
        by the Partner cannot be lower than the minimum price set out by the
        Provider in TIER2 stores. The price may be changed by the Provider, when
        the Provider finds out that the price set out by the Partner does not
        cover costs necessary to manufacture the final product due to
        complicated design of product proposed by the Partner.
      </Typography>
      <Typography paragraph>
        14. The Partner acknowledges that the price paid by the User for the
        items purchased during the usage of the store will cover the NFT costs,
        together with the buyer's commission and the cost of production of the
        physical item. The Partner is eligible to set the price of each item and
        this price should be specified as the mint price of the item. The
        Partner should carefully calculate all costs involved with production of
        the physical item to ensure that the price presented as minting price
        covers all costs of production.
      </Typography>
      <Typography paragraph>
        15. Partner will not cover the cost of the packaging and shipping of the
        package to the country of destination chosen by the User. The costs
        meant above shall be paid by the User during the redeem process.
      </Typography>
      <Typography paragraph>
        16. Users fully acknowledge that shipping costs vary from country to
        country and can change over time according to fuel rates and
        subcontractors' operating costs.
      </Typography>
      <Typography paragraph>
        17. In TIER1 stores, Partner sets the shipping price of each product
        which may be valued from 0 to 45USD, receives the Users' payments for
        shipping and is responsible to ship the items to the Users. Provider is
        eligible for additional transaction fees associated with processing the
        shipping payments.
      </Typography>
      <Typography paragraph>
        18. In TIER2 stores Provider sets and receives the Users' payments for
        shipping and is responsible for shipping the items to the Users.
      </Typography>
      <Typography paragraph>
        19. Before the Partner handles the payment for the store, Partner is
        obliged to provide Provider with all information required to
        successfully issue the invoice to the Partner the exact data necessary
        to issue the invoice shall be specified in the Store Generator.
      </Typography>
      <Typography paragraph>
        20. If the Partner is the natural person or any form of legal entity
        with the residential address (natural persons) or business address (any
        and all business entities including companies, partnerships and
        entrepreneurs acting as sole entrepreneur) on the territory of one of
        member states of European Union, the Store price, mint price and redeem
        price shall be increased by the proper amount of Value Added Tax (VAT)
        with regard to the applicable rules of taxation of Value Added Tax in
        European Union.
      </Typography>
      <Typography paragraph>
        21. All prices for services offered by Provider presented to the
        potential Partner on the website of Provider are net prices. If the
        transaction between Provider and the Partner is a taxable transaction
        under the regulations of Value Added Tax (VAT), the final price of the
        service will be increased by the amount of Value Added Tax applicable to
        the transaction.
      </Typography>
      <Typography paragraph>
        22. Partner may request to modify or upgrade the store at any time.
        Changes involving extending the offer, extending the number of products
        above the limit presented in the Store Generator will be accepted
        individually and paid separately by the Partner.
      </Typography>
      <Typography paragraph>
        23. Partner accepts and acknowledges that the mint of all NFT tokens
        offered in the digital store is handled on the Polygon blockchain
        network.
      </Typography>
      <Typography paragraph>
        24. Partner will choose blockchain networks for the payments for items
        offered through the store and tokens accepted as form of payment.
      </Typography>
      <Typography paragraph>
        25. Payment for mint and redeem may occur on the POLYGON, ETHEREUM and
        BSC blockchain network. Provider will accept payments in: WETH, MATIC,
        UNIQ for POLYGON, ETH, UNIQ, USDC for ETHEREUM, BNB for BSC. Partner
        accepts and acknowledges that the mint and redeem of all NFT tokens
        offered in the digital store is handled on POLYGON blockchain network.
      </Typography>
      <Typography paragraph>
        26. Provider enables Users to pay with FIAT currencies.
      </Typography>
      <Typography paragraph>
        27. Payment for redeem covers costs of shipment and the box (premium or
        standard, upon the decision of the User) for the physical product.
        Premium boxes are available only in TIER2 Stores.
      </Typography>
      <Typography paragraph>
        28. Provider is eligible to charge additional fees for redeem operation.
        The regular fee for the redeem is 5% but the percentage of fee may
        change in the future.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        V. REDEMPTION
      </Typography>
      <Typography paragraph>
        1. The Buyer shall read, understand and accept the Uniqly Terms of
        Service, Privacy Policy and Store Generator Terms of Service, as well as
        provide the contact and delivery information on the Redeem Form in order
        to redeem an NFT.
      </Typography>
      <Typography paragraph>
        2. When the User redeems the NFT in TIER1 stores, Partner will have the
        Item delivered to the User within the Shipment Time set for each product
        in the Store Generator (tab “Products” → “Shipment” → “Shipment time”)
        by the Partner.
      </Typography>
      <Typography paragraph>
        3. When the User redeems the NFT in TIER2 stores, Provider will have the
        item delivered to the User from 10 to 45 days from the redemption date.
      </Typography>
      <Typography paragraph>
        4. The items can be redeemed by the Users only on the dates specified by
        the Partner in the Store Generator (tab: “Products” → “Redeem” → “Redeem
        time limit”). The maximum redeem time limit cannot exceed the store
        duration.
      </Typography>
      <Typography paragraph>
        5. If the Partner is unable to deliver the redeemed item to the User,
        the Partner will inform the User immediately. The Partner can only
        misdeliver the Item if it is out of stock, there was an error in the
        price or description of the Item, or the Partner is not able to ship the
        item to the User’s country.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        VI. RETURNS
      </Typography>
      <Typography paragraph>
        1. Returns are accepted by the Seller subject to the below conditions.
      </Typography>
      <Typography component="div">
        <Typography paragraph>
          2. In order to claim a return, the User must comply with the
          following:
        </Typography>
        <ol type="a">
          <li>
            The User must contact the Partner/Provider about the will to return
            or exchange the item within the return period set in accordance with
            the principles regulated by Polish provisions contained in the Act
            of the Provision of Electronic Services via the contact method (
            <CustomLink href={`mailto:${CONTACT_UNIQLY_EMAIL}`}>
              contact@uniqly.io
            </CustomLink>{" "}
            or Partner e-mail address available on the minted/redeemed Product
            page).
          </li>
          <li>
            The Item must be in the original condition, packed in the original
            packaging and unused. If the Item is not returned as described, the
            return or exchange will not be accepted.
          </li>
          <li>
            In order to complete a return, the User must deliver the proof to
            the Partner/Provider. It can be the e-mail confirmation of the
            redeem.
          </li>
          <li>
            Returns are not applicable to digital items, custom-made products,
            or items that cannot be reused for hygiene reasons.
          </li>
          <li>
            In order to return the item, it should be sent by the User to the
            address specified by Partner/Provider.
          </li>
          <li>
            The User is responsible to pay all the costs associated with
            returning the Item.
          </li>
        </ol>
      </Typography>
      <Typography paragraph>
        3. The User is aware that any fees related to customs, duties and taxes
        on the delivery of the items are not covered by Partner/Provider and
        cannot demand Partner/Provider to cover these costs.
      </Typography>
      <Typography paragraph>
        4. As a result of non-payment of fees related to customs, duties and
        taxes by the User, the User is not entitled to claim a refund for the
        purchased goods.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        VII. COPYRIGHTS AND INTELLECTUAL PROPERTY
      </Typography>
      <Typography component="div">
        <Typography paragraph>
          1. Copyrights of the Provider and no licence rule:
        </Typography>
        <ul>
          <li>
            The Partner confirms, certifies, accepts and fully acknowledges that
            this agreement does not grant, assign, transfer or establish any
            copyrights to the Partner or to any other entity.
          </li>
          <li>
            The Provider allows the use of the logo for marketing purposes,
            after prior approval of its location and exposure.
          </li>
          <li>
            The Provider allows the use of the logo for marketing purposes,
            after prior approval of its location and exposure.
          </li>
          <li>
            Partner confirms, certifies, accepts and fully acknowledges that the
            definition of copyrights under the power of this agreement covers
            any and all copyrights arising from the cooperation of the Parties
            including, but not limited to copyrights to any source code of
            computer programmes, computer programmes itself as a whole or any
            parts of computer programmes, databases, graphics, animations or any
            other visualisation presented in any form, especially by
            presentation on the websites in the form of pictures or parts of XML
            / HTML code or by any other technical method enabling browser to
            display graphics on the screen of the end user.
          </li>
          <li>
            Unless otherwise resolved, all copyrights belong to the Provider and
            the Partner is not, under any circumstances authorised, appointed,
            entitled or eligible to participate in any profits, incomes,
            revenues or any other earnings generated by the copyrights meant
            above.
          </li>
          <li>
            Partner confirms, certifies, accepts and fully acknowledges that any
            transfer of any copyrights shall be made in a separate written
            agreement concluded between Parties and covering details and
            essential elements of any future transfer of copyrights.
          </li>
        </ul>
        <Typography paragraph>2. Copyrights of the Partner:</Typography>
        <ul>
          <li>
            Partner fully confirms and states that the Partner owns copyrights
            to the graphics and designs submitted to the Provider. This
            condition does not apply to the implementation of TIER3 stores.
          </li>
          <li>
            Partner fully accepts and acknowledges that the Partner is solely
            liable for any loss or damage caused by any possible infringement of
            any copyrights belonging to a third party.
          </li>
          <li>
            Provider is not obliged to check whether or not the designs provided
            by the Partner infringes any copyrights of any person.
          </li>
        </ul>
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        VIII. DURATION OF THE COOPERATION BETWEEN PARTIES
      </Typography>
      <Typography paragraph>
        1. The cooperation between the Provider and Partner lasts for the time
        on which the store is paid.
      </Typography>
      <Typography paragraph>
        2. The cooperation between Partner and Provider regarding store services
        shall expire on the date by which it was paid by deactivating the Store
        and blocking the possibility of further purchases on the Store by the
        Users.
      </Typography>
      <Typography paragraph>
        3. Partner can resume the store service by paying the fee for the next
        period of his choice in the Store Generator.
      </Typography>
      <Typography paragraph>
        4. If the Partner fails to pay the price for the store, in accordance
        with the provisions above, the contract between the Provider and the
        Partner shall automatically expire and the cooperation of the Provider
        and Partner shall be terminated automatically.
      </Typography>
      <Typography paragraph>
        5. Each Party of this contract is entitled to terminate the contractual
        relationship established under the power of this Terms & Conditions of
        Service with a one month period of termination.
      </Typography>
      <Typography paragraph>
        6. Any termination shall be made by email{" "}
        <CustomLink href={`mailto:${CONTACT_UNIQLY_EMAIL}`}>
          contact@uniqly.io
        </CustomLink>
        .
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        IX. DISPUTE RESOLUTION
      </Typography>
      <Typography paragraph>
        1. The User/Partner has the right to raise a complaint and withdraw from
        the contract in accordance with the principles governed by Polish
        provisions contained in the following acts: the Civil Code, Consumer
        Rights Act, Provision of Electronic Services Act and Competition and
        Consumer Protection Act.
      </Typography>
      <Typography paragraph>
        2. If the Offer is not fulfilled in accordance with the Store Generator
        Terms of Service and the Uniqly Terms of Service, the User and Partner
        can raise a complaint within 1 year from redeeming the item (applicable
        to Users) and 1 year from the Store Start date (applicable for the
        Partners).
      </Typography>
      <Typography paragraph>
        3. The User/Partner has the right to start a dispute between the parties
        to the concluded contract on the basis of a legitimate reason.
      </Typography>
      <Typography paragraph>
        4. The scope of responsibility for the activities performed is described
        in the following document in accordance with the selected Store Tiers.
      </Typography>
      <Typography paragraph>
        5. As a result of failure to meet the Store Generator Terms and
        Conditions or doubts regarding their performance, the User should report
        the dispute to the appropriate party and demand its resolution.
      </Typography>
      <Typography paragraph>
        6. Partner/Provider must consider the complaint within 14 days from the
        date of raising a complaint by the User. The new item must be handed
        over to the user within 30 days from the date when the complaint is
        considered (deadlines may be extended due to reasons beyond the control
        of Partner/Provider).
      </Typography>
      <Typography paragraph>
        7. If the complaint applies to the Store, the Partner can raise a
        complaint to Provider by e-mail (
        <CustomLink href={`mailto:${CONTACT_UNIQLY_EMAIL}`}>
          contact@uniqly.io
        </CustomLink>
        ).
      </Typography>
      <Typography paragraph>
        8. If the complaint applies to the mint operations in TIER1 stores and
        mint and redeem operations in TIER2 stores, the User can raise a
        complaint to Provider by e-mail (
        <CustomLink href={`mailto:${CONTACT_UNIQLY_EMAIL}`}>
          contact@uniqly.io
        </CustomLink>
        ).
      </Typography>
      <Typography paragraph>
        9. If the complaint applies to the redeem operation in TIER1 stores, the
        User can raise a complaint to the Partner by e-mail (e-mail is listed on
        each minted or redeemed item site).
      </Typography>
      <Typography paragraph>
        10. The User, Partner and Provider shall attempt to resolve the Dispute
        mutually by communicating via the applicable contact method. Once an
        agreement is reached, User, Partner or Provider signs the Dispute off
        with a message indicating the agreed-upon solution.
      </Typography>
      <Typography paragraph>
        11. The Partner/Provider is not obliged to accept the returns of the
        items, unless it is due to a complaint or a dispute.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        X. LIMITATIONS OF LIABILITY
      </Typography>
      <Typography paragraph>
        1. Parties agree that nothing in this Terms and Conditions of Service or
        in the agreement concluded between Provider and Partner under the power
        of this Terms and Conditions of Service construes any express or implied
        liability of the Provider.
      </Typography>
      <Typography paragraph>
        2. The Provider is not liable for any possible taxes involved with any
        business or personal activity of the Partner and any possible earnings
        arising out of this activity.
      </Typography>
      <Typography paragraph>
        3. Partner fully accepts, certifies and acknowledges that the Partner is
        solely liable for all taxes and other legal obligations in accordance
        with the laws of jurisdiction of Partner.
      </Typography>
      <Typography paragraph>
        4. By the power of this Terms and Conditions of Service Partner
        irrevocably releases Provider as well as the Directors, agents,
        employees or any other representatives of Provider from any express or
        implied liability for any loss, damage including loss of any future
        benefits and unearned revenues or any profits. The release of liability
        covers all possible situations involved with the activity of Provider
        including discontinuation of Provider's business activity at any reason,
        interruption of performance of the website, any digital risks involved
        with the website and security of data holding by Provider, and
        regardless of the cause of the situations listed above.
      </Typography>
      <Typography paragraph>
        5. By the power of this Terms & Conditions Partner fully accepts his
        unlimited liability for any possible infringement of any intellectual
        property rights or any copyrights of any third party. Thus Provider
        shall be free from any express or implied liability for any possible
        loss or any other form of legal responsibility including but not limited
        to damages, compensations and other penalties which may be imposed by
        court of law or any other institution authorised to control the usage
        and execute fees or penalties for infringement of any intellectual
        property rights or copyrights belonging to any person, legal or natural.
      </Typography>
      <Typography paragraph>
        6. By the power of this Terms & Conditions Partner fully accepts his
        unlimited liability for any taxes, duties and customs arising out of or
        in any manner involved with their business activity handled by the
        digital store provided by Provider.
      </Typography>
      <Typography paragraph>
        7. By the power of this Terms & Conditions Partner fully accepts his
        unlimited liability arising out of business relationship between Partner
        and third party purchasing product in the store. The liability covers
        any and all subjects involved with taxation as well as transportation
        (shipment) of goods purchased by Users in store belonging to the
        Partner.
      </Typography>
      <Typography paragraph>
        8. Thus Partner certifies that the Partner is fully aware of any and all
        possible consequences of trading of digital goods like NFTs and
        providing physical goods.
      </Typography>
      <Typography paragraph>
        9. Provider shall be free from any express or implied legal liability
        for any taxes, duties or customs arising out of or in any manner
        involved with business activity of the Partner.
      </Typography>
      <Typography paragraph>
        10. Partner has sufficient Intellectual Property Rights over the
        submitted designs and is fully liable for the quality of provided images
        - the minimum resolution of each picture (design) is 300 DPI. Provider
        accepts files in formats: SVG, JPG, JPEG, PNG.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        XI. THE USERS’ RIGHTS
      </Typography>
      <Typography paragraph>
        1. Users and Partners residing in the EU and other territories are
        entitled to appropriate legal provisions regarding the processing and
        usage of personal data.
      </Typography>
      <Typography component="div">
        <Typography paragraph>
          2. The User, in accordance with the provisions of law, has the right
          to:
        </Typography>
        <ol type="a">
          <li>
            Receive a copy of their personal data that has been provided for the
            purposes of Provider services.
          </li>
          <li>
            Change, delete and limit the use of personal data by the
            Partner/Provider.
          </li>
          <li>
            File a complaint regarding the processing and use of personal data.
          </li>
        </ol>
      </Typography>
      <Typography paragraph>
        3. Provider, respecting the personal data of Users and Partners,
        complies with all the principles adopted in a separate Privacy Policy
        document.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        XII. ADDITIONAL SERVICES
      </Typography>
      <Typography paragraph>
        1. Partner may order additional services like adding payment custom
        token issued by the Partner for the store to be used as digital means of
        payment enabling users to purchase goods offered by the store or
        increasing the number of available items at his store.
      </Typography>
      <Typography paragraph>
        2. Additional services are not included in the price presented on the
        Provider website.
      </Typography>
      <Typography paragraph>
        3. If Partner wants to extend the scope of cooperation with Provider by
        ordering a custom token, the price of this service will be added
        automatically to the price presented on the website.
      </Typography>
      <Typography paragraph>
        4. Parties collectively agree that the agreement between Parties meant
        above may be concluded by email{" "}
        <CustomLink href={`mailto:${CONTACT_UNIQLY_EMAIL}`}>
          contact@uniqly.io
        </CustomLink>{" "}
        correspondence between the Parties containing request of Partner to
        introduce additional services and the confirmation & acceptance of
        conditions of additional cooperation by both Parties.
      </Typography>
      <Typography component={"h3"} variant="h3" paragraph>
        XIII. AMENDMENTS TO THIS TERMS AND CONDITIONS OF SERVICE
      </Typography>
      <Typography paragraph>
        1. These Terms and Conditions of Service may be amended from time to
        time.
      </Typography>
      <Typography paragraph>
        2. Provider reserves for himself unlimited right to amend, supplement,
        correct or change this Terms and Conditions of Service any time at his
        own independent discretion.
      </Typography>
      <Typography paragraph>
        3. Any amendments to this Terms and Conditions of Service will be
        published on the UNIQLY.IO website.
      </Typography>

      <Typography component={"h3"} variant="h3" paragraph>
        XIV. APPLICABLE LAW & JURISDICTION
      </Typography>
      <Typography paragraph>
        1. Parties to this agreement mutually agree that this contract concluded
        under the power of this Terms and Conditions as well as all obligations
        arising out of the contract shall be governed by the law of the United
        States of America.
      </Typography>
      <Typography paragraph>
        2. Any disputes between parties of this agreement concluded under the
        power of this Terms and Conditions, concerning or arising from the
        performance, execution or interpretation of this agreement or involved
        with this agreement in any manner, shall be settled and resolved by the
        competent court of law in accordance with the seat of the Provider.
      </Typography>
    </Layout>
  );
};

export default TermsPage;
